var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrd = function SvgPrd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#PRD_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#PRD_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 2,
    fill: "#14B8A6",
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#PRD_svg__c)",
    d: "M0 0h20v20H0z",
    transform: "translate(2)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#PRD_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#PRD_svg__e)",
    d: "M6.375 4.844h9c.788 0 1.181 0 1.482.153.265.135.48.35.615.615.153.3.153.694.153 1.482v.562h-9c-.788 0-1.181 0-1.482-.153a1.4 1.4 0 0 1-.615-.615c-.153-.3-.153-.694-.153-1.482z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#PRD_svg__f)",
    d: "M6.375 11.406h9c.788 0 1.181 0 1.482-.153.265-.135.48-.35.615-.615.153-.3.153-.694.153-1.482v-.562h-9c-.788 0-1.181 0-1.482.153-.265.135-.48.35-.615.615-.153.3-.153.694-.153 1.482z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#PRD_svg__g)",
    d: "M10.75 12.344h4.625c.788 0 1.181 0 1.482.153.265.135.48.35.615.615.153.3.153.694.153 1.482v.562H13c-.788 0-1.181 0-1.482-.153a1.4 1.4 0 0 1-.615-.615c-.153-.3-.153-.694-.153-1.482z"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 19.167,
    height: 19.167,
    x: 2.417,
    y: 0.417,
    stroke: "url(#PRD_svg__h)",
    strokeWidth: 0.833,
    rx: 5.583
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "PRD_svg__c",
    x1: 10,
    x2: 10.833,
    y1: 0,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "PRD_svg__e",
    x1: 12,
    x2: 12,
    y1: 4.844,
    y2: 15.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "PRD_svg__f",
    x1: 12,
    x2: 12,
    y1: 4.844,
    y2: 15.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "PRD_svg__g",
    x1: 12,
    x2: 12,
    y1: 4.844,
    y2: 15.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "PRD_svg__h",
    x1: 12,
    x2: 12,
    y1: 0,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "PRD_svg__a",
    width: 22.5,
    height: 23.75,
    x: 0.75,
    y: -1.25,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.417
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.208
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.162923 0 0 0 0 0.162923 0 0 0 0 0.162923 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_395_7440"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 0.417,
    result: "effect2_dropShadow_395_7440"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.833
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.164706 0 0 0 0 0.164706 0 0 0 0 0.164706 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_395_7440",
    result: "effect2_dropShadow_395_7440"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_395_7440",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.625
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect3_innerShadow_395_7440"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.625
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect3_innerShadow_395_7440",
    result: "effect4_innerShadow_395_7440"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 0.417,
    result: "effect5_innerShadow_395_7440"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect4_innerShadow_395_7440",
    result: "effect5_innerShadow_395_7440"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "PRD_svg__d",
    width: 13.75,
    height: 17.5,
    x: 5.125,
    y: 2.188,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 0.625,
    result: "effect1_dropShadow_395_7440"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.938
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.938
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_395_7440"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_395_7440",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "PRD_svg__b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 2,
    fill: "#fff",
    rx: 6
  })))));
};
export default SvgPrd;